<template>
  <div class="mt-4 d-flex" :class="[getPrevRoute ? 'justify-space-between' : 'justify-end']">
    <v-btn text @click="prevStep" v-if="getPrevRoute">
      <v-icon>mdi-chevron-left</v-icon>
      {{
        isPrevJourney
          ? $ucfirst($t('buttons.goToJourney', {catalog: 'app_mobile'}))
          : $ucfirst($t('buttons.previousStep', {catalog: 'app_mobile'}))
      }}
    </v-btn>
    <v-btn text @click="nextStep" v-if="getNextRoute">
      {{
        isNextJourney
          ? $ucfirst($t('buttons.goToJourney', {catalog: 'app_mobile'}))
          : $ucfirst($t('buttons.nextStep', {catalog: 'app_mobile'}))
      }}
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>

/**
 * Component DiscussionStepNavButtons.vue
 *
 * @module DiscussionStepNavButtons
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/DiscussionStepNavButtons.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "DiscussionStepNavButtons",
  props: ["nextRoutes", "prevRoutes"],
  computed: {
    getNextRoute() {
      const parentName = this.$route.matched[this.$route.matched.length-1].parent.name;
      return this.nextRoutes[this.$route.name]
        ? this.nextRoutes[this.$route.name]
        : this.nextRoutes[parentName]
    },
    getPrevRoute() {
      const parentName = this.$route.matched[this.$route.matched.length-1].parent.name;
      return this.prevRoutes[this.$route.name]
        ? this.prevRoutes[this.$route.name]
        : this.prevRoutes[parentName]
    },
    isNextJourney() {
      return this.getNextRoute === 'PatientRecordProgress'
    },
    isPrevJourney() {
      return this.getPrevRoute === 'PatientRecordProgress'
    }
  },
  methods: {
    nextStep() {
      this.$router.push({ name: this.getNextRoute })
    },
    prevStep() {
      this.$router.push({ name: this.getPrevRoute })
    }
  }
};
</script>

<style lang="scss">
</style>
